export default (inputs = []) => {
  let fields = {};
  inputs.forEach(inp => {
    fields = {...fields, [inp.name]: {value: inp.value, validators: inp.validators, valid: inp.valid}};
  });
  return {
    ...fields,
    fieldsName: Object.keys(fields),
    valid: false,
    get: function (key = '') { return this[key]; },
    set: function (key = '', value = '') { if(this[key]) this[key].value = value; },
    setValidator: function (key = '', validatorName = '', validator) { this[key].validators[validatorName] = validator; },
    removeValidator: function (key = '', validatorName = '') { delete this[key].validators[validatorName] },
    setValid: function(key, valid = false) { this[key].valid = valid; },
    setInput: function (input) { this[input.name] = {value: input.value, validators: input.validators, valid: input.valid}; this.fieldsName = [...this.fieldsName, input.name] },
    remove: function (key = '') { delete this[key] },
  };
}